import { Component } from '@angular/core';
import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';

@Component({
  selector: 'itpx-credit',
  templateUrl: './credit.component.html',
  styleUrls: ['./credit.component.css']
})
export class CreditComponent {

    private url: string;
    private detailsRoute: string = '/agora/account-data/credit/{{key}}/details';
    private fields: Array<any> = [
        {
            title: 'Date',
            name: 'createdAt',
            config: {
                type: 'date'
            },
            sortable: true
        }, {
            title: 'Buyer Name',
			name: 'buyerName',
			config: {
				type: 'link',
				route: this.detailsRoute,
				key: 'id'
            },
            sortable: true
		}, {
            title: 'Buyer ID',
			name: 'buyerId',
			config: {
				type: 'link',
				route: this.detailsRoute,
				key: 'id'
            },
            sortable: true
		},{
            title: 'Username',
            name: 'userName',
            sortable: true
        },
		{
            title: 'Status',
            name: 'status.configValue',
            sortable: true
        }, {
            title: 'Decision',
            name: 'creditDecision.decision.configValue',
            sortable: true
        }
    ];

	constructor( private configService: ConfigService ) {
        this.url = this.configService.get('server').url + this.configService.get('endpoints').agora.credit.list.api;
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/credit/credit.component.ts